export function getFocusedElementId() {
    return document.activeElement.id
}
export function findElementAndFocus(elemId) {
    let elem = document.getElementById(elemId)
    elem.focus()
}
export function isPromise(func) {
    return func.then && typeof func.then === 'function'
}
export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
export function facebookPixel(_eventName) {
    $window.fbq('trackCustom', _eventName, { myParam: _eventName });
}

export function isEditMode() {
    console.log("isEditMode")
    var url = window.location.pathname;

    var filename = url.substring(url.lastIndexOf('/') + 1);

    return (filename == "edit.aspx" || filename == "Edit.aspx")
}

export function pushDatalayerAddtoCart(name, productid, price, producttype, donationtype) {
    console.log(window)
    if (window.dataLayer != undefined) {
        window.dataLayer.push({
            event: "addToCart",
            ecommerce: {
                currencyCode: "AUD",
                add: {
                    products: [
                        {
                            // List of productFieldObjects.
                            name: name, // Name or ID is required.
                            id: producttype + "|" + donationtype + "|" + productid,
                            price: price,
                            quantity: "1",
                            'category': producttype,
                            'variant': donationtype
                        }
                    ]
                }
            }
        });
    }
}

export function pushDatalayerCheckout(name, productid, price, producttype, donationtype) {
    if (window.dataLayer != undefined) {
        window.dataLayer.push({
            event: "checkout",
            ecommerce: {
                currencyCode: "AUD",
                checkout: {
                    products: [
                        {
                            // List of productFieldObjects.
                            name: name, // Name or ID is required.
                            id: producttype + "|" + donationtype + "|" + productid,
                            price: price,
                            quantity: "1",
                            'category': producttype,
                            'variant': donationtype
                        }
                    ]
                }
            }
        });
    }
}

export function pushDatalayerDetail(name, productid, producttype, donationtype) {
    if (window.dataLayer != undefined) {
        window.dataLayer.push({
            ecommerce: {
                detail: {
                    products: [
                        {
                            // List of productFieldObjects.
                            name: name, // Name or ID is required.
                            id:  producttype + "|" + donationtype + "|" + productid,
                            quantity: '1',
                            'category': producttype,
                            'variant': donationtype,
                        }
                    ]
                }
            }
        });
    }
}
export function pushDatalayerPurchase(transactionid, name, productid, producttype, donationtype, price, postcode, paymenttype) {
    if (window.dataLayer != undefined) {
        window.dataLayer.push({
            'event': 'purchase',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': transactionid,
                        'affiliation': 'WWF Online Shop',
                        'revenue': price,
                        'tax': '0.00',
                        'shipping': '0.00',
                    },
                    'products': [{ // List of productFieldObjects.
                        'name': name, // Name or ID is required.
                        'id': producttype + "|" + donationtype + "|" + productid,
                        'price': price,
                        'category': producttype,
                        'variant': donationtype,
                        'quantity': '1',
                        'dimension4': postcode,
                        'dimension5': paymenttype
                    }],
                }
            }
        });
    }
}

export function getNameByDonatiuonType(type) {

    let typename = null;

    switch (type) {
        case "Single":
            typename = "Single Donation";
            break;
        case "Regular":
            typename = "Monthly Donation";
            break;
        case "Annual":
            typename = "Annual Donation";
            break;
        default:
            typename = "Other Donation";
    }
    return typename;
}

export function getNameByPaymentType(type) {
    
        let typename = null;
    
        switch (type) {
            case "wwf_purchasetokenise":
                typename = "Credit card";
                break;
            case "wwf_directdebit":
                typename = "Direct debit";
                break;
            case "wwf_paypal":
                typename = "Paypal";
                break;
            default:
                typename = "Other";
        }
        return typename;
    }

    export function getTaxBrackeList()
    {
        return [
            { bracket: '$18201 - $37000', tax: '0.19' },
            { bracket: '$37001 - $87000', tax: '0.325' },
            { bracket: '$87001 - $180000', tax: '0.37' },
            { bracket: 'Over $180000', tax: '0.45' }
         ];
    }

export function getCountriesList() {
    
        let countries = require('./store/countries.json');

        return countries;
    }
export function getCountriesListForMenu() {
    let countriesForMenu = require('./store/countriesForMenu.json');

    return countriesForMenu;
}

const POSTCODE_RANGES = require('./postcodes.json');

// https://en.wikipedia.org/wiki/Postcodes_in_Australia
export function getAustralianStateByPostcode(postcode) {
    if (isNaN(postcode)) {
        throw new Error('Postcode is not a number');
    }

    postcode = Number(postcode);
    for (const state of Object.keys(POSTCODE_RANGES)) {
        const ranges = POSTCODE_RANGES[state];

        for (const r of ranges) {
            if (postcode >= r[0] && postcode <= r[1]) {
                return state;
            }
        }
    }

    return null;
}


// WEBPACK FOOTER //
// ./src/helpers.js